/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateIncidentComment200ResponseData
 */
export interface CreateIncidentComment200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof CreateIncidentComment200ResponseData
     */
    id?: string;
}

/**
 * Check if a given object implements the CreateIncidentComment200ResponseData interface.
 */
export function instanceOfCreateIncidentComment200ResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateIncidentComment200ResponseDataFromJSON(json: any): CreateIncidentComment200ResponseData {
    return CreateIncidentComment200ResponseDataFromJSONTyped(json, false);
}

export function CreateIncidentComment200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIncidentComment200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function CreateIncidentComment200ResponseDataToJSON(value?: CreateIncidentComment200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

